import { useState, useEffect } from "react";
import { GetWorkCardHours } from "../../../actions/teacherQueries";

const getTreeId = (item) =>
  item.isComponent ? `component-${item.id}` : `step-${item.id}`;

const getTreeParentId = (item) =>
  item.parentId === null ? null : `step-${item.parentId}`;

export default function useAPLWorkCardData(
  level,
  activePeriodId,
  objId,
  setPromptComponentForDelete,
  setWorkcardItemForEditName,
  setAddNewWorkStepComponentOpen
) {
  const [studentParticipation, setStudentParticipation] = useState(null);
  const [totalWorkHoursRegistered, setTotalWorkHoursRegistered] = useState(0);
  const [currentWorkStepForAddComponent, setCurrentWorkStepForAddComponent] =
    useState(null);

  const workCardHourData = GetWorkCardHours(level, activePeriodId, objId);

  useEffect(() => {
    if (workCardHourData.isPending) {
      setStudentParticipation(null);
      setTotalWorkHoursRegistered(0);
      return;
    }

    if (workCardHourData.data != null) {
      const handleSetWorkStepAndToggleComponentModal = (workstepId) => {
        setCurrentWorkStepForAddComponent(workstepId);
        setAddNewWorkStepComponentOpen(true);
      };

      let tableData = [];
      let totalWorkHours = 0;

      workCardHourData.data.forEach((wsi) => {
        if (wsi.isComponent) {
          totalWorkHours += wsi.hours;
        }
        const itemToAdd = {
          ...wsi,
          id: getTreeId(wsi),
          parentId: getTreeParentId(wsi),
          rawId: wsi.id,
        };
        itemToAdd.edit = {
          onDelete: () =>
            setPromptComponentForDelete({
              id: wsi.id,
              name: wsi.name,
              isWorkstep: wsi.parentId === null,
              hours: wsi.hours,
              parentId: wsi.parentId,
            }),
          onEdit: () =>
            setWorkcardItemForEditName({
              id: wsi.id,
              name: wsi.name,
              isWorkstep: wsi.parentId === null,
              parentId: wsi.parentId,
            }),
        };
        tableData.push(itemToAdd);
      });

      const tempWorkSteps = tableData.filter((item) => item.parentId === null);
      tempWorkSteps.forEach((ws) => {
        tableData.push({
          parentId: ws.id,
          name: {
            onAddComponent: () =>
              handleSetWorkStepAndToggleComponentModal(ws.rawId),
          },
          hours: null,
        });
      });

      tableData = tableData.sort((a, b) => {
        if (a === null) {
          return 1;
        }
        if (b === null) {
          return -1;
        }
        return a.hours < b.hours ? 1 : -1;
      });

      setTotalWorkHoursRegistered(totalWorkHours);
      setStudentParticipation(
        tableData.sort((a, b) => {
          return a.hours < b.hours ? 1 : -1;
        })
      );
    } else {
      setStudentParticipation(null);
      setTotalWorkHoursRegistered(0);
    }
  }, [
    workCardHourData.data,
    workCardHourData.isPending,
    setAddNewWorkStepComponentOpen,
    setPromptComponentForDelete,
    setWorkcardItemForEditName,
  ]);

  const columnExtensions = [
    { columnName: "hours", width: 350 },
    { columnName: "name", width: 350 },
    { columnName: "edit", width: 100 },
  ];

  const columns = [
    { title: "Namn", name: "name" },
    { title: "Antal timmar elever registrerat", name: "hours" },
    { title: "Redigera", name: "edit" },
  ];

  return {
    studentParticipation,
    totalWorkHoursRegistered,
    currentWorkStepForAddComponent,
    workCardHourData,
    columns,
    columnExtensions,
  };
}
